import React from "react";

const CheckmarkOpenCdo = (props) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" style={{ marginRight: props.marginRight !== undefined ? props.marginRight : '10px', flex: 'none' }} aria-labelledby={props.ariaLabelledby} role={props.role} >
            <title id={props.id + '-selected'}>Selected</title>
            <polygon
                fill={props.fill || "#FFFFFF"}
                fillRule="nonzero"
                points="7.77 13.29 4.44 10.0 3.33 11.1 7.77 15.48 17.29 6.1 16.18 5.0"
            />
        </svg>
    )
}

export default CheckmarkOpenCdo;
